<template>
    <!-- <div class="el-input w-2 block"> -->
        <div class="el-input is-disabled el-input--suffix">
            <div class="loader mt-2 ml-3"></div>
            <span class="el-input__inner pl-6">
                {{ label }}
            </span>

            <span class="el-input__suffix">
                <span class="el-input__suffix-inner">
                    <i class="el-input__caret el-input__icon el-icon-arrow-up"></i>
                </span>
            </span>
        </div>
    <!-- </div> -->
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            require: false,
            default: ""
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';
    .loader {
        border: 2px solid #8C909C;
        border-bottom: 2px solid #f4f6f9;
        border-radius: 50%;
        background-color: #f4f6f9;
        width: 16px;
        height: 16px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    .el-input.is-disabled .el-input__inner{
        line-height: 32px !important;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>